<div class="expanded-panel-header teal" (click)="toggleExpand()">ESG & Supportive Services</div>
@if(expanded){
  <div class="row">
    <div class="expanded-panel-header teal-light">Unit Set-Asides</div>
    <table>
      <thead>
      <tr>
        <th>Set-Aside Type</th>
        <th>Number of Units</th>
        <th>Hard/Best Efforts</th>
      </tr>
      </thead>
      <tbody>
        @for(set of unitSetAsides; track $index){
          <tr>
            <td>{{set.set_aside_type ?? '--'}}</td>
            <td>{{set.units ?? '0'}}</td>
            <td>{{set.hard_or_best_efforts ?? '--'}}</td>
          </tr>
        }
      </tbody>
    </table>
    <div class="expanded-panel-header teal-light">Economic Impact</div>
    @for(row of economicRows; track $index){
      <div class="row" style="padding-left: 8px;padding-right: 8px;">
        @for(field of row; track field.key){
          <div class="col-md-6">
            <div class="row align-top" style="border-bottom: 1px solid lightgray">
              <div class="col-md-6 label">{{ field.label }}</div>
                @if(field.key=='total_lihtc_units' || field.key=='jobs_created'){
                  <div class="col-md-6">{{detail[field.key] ?? '--'}}</div>
                }
                @if(field.key!=='total_lihtc_units' && field.key!=='jobs_created'){
                  <div class="col-md-6">{{detail[field.key] ? (detail[field.key] | currency: 'USD': 'symbol': '1.2-2') : '--'}}</div>
                }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
